module.exports = __webpack_public_path__ + "static/img/组 2884.fbef140.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2884.png
// module id = dV4j
// module chunks = 0